import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A talk that changes everything",
  "description": "",
  "published": "2012-02-28T00:00:00.000Z",
  "redirect_from": ["/blog/a-talk-that-changes-everything/swizec/3712"],
  "categories": "Apple, Bret Victor, Principle, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This talk by `}<a parentName="p" {...{
        "href": "http://worrydream.com/",
        "title": "Bret Victor"
      }}>{`Bret Victor`}</a>{` has changed my entire perspective on programming and how I want to continue working in this field. It starts out a bit slow, but you `}<em parentName="p">{`should`}</em>{` watch it. Well worth it, I promise.`}</p>
    <p><a parentName="p" {...{
        "href": "http://vimeo.com/36579366"
      }}>{`Bret Victor - Inventing on Principle`}</a>{` from `}<a parentName="p" {...{
        "href": "http://vimeo.com/cusec"
      }}>{`CUSEC`}</a>{` on `}<a parentName="p" {...{
        "href": "http://vimeo.com"
      }}>{`Vimeo`}</a>{`.`}</p>
    <p>{`A quick recap of the more salient points for all you lazy bastards out there who aren't willing to devote an hour of your time to expanding your horizons.`}</p>
    <p><strong parentName="p">{`1.`}</strong>{` To be creative, you need an immediate, direct connection to what you're doing, none of that "several layers of abstraction on top of abstraction and thinking ten steps ahead to understand what's going on" ... why would you have to emulate a computer in your head when you have one right there?`}</p>
    <p><strong parentName="p">{`2. `}</strong>{`When inventing new things, perhaps we shouldn't be thinking about creating cool products or hacking the awesomest algorithm or even the most elegant design both in code and UX - perhaps we should find a principle and stick to it? Once you have that principle, everything else follows.`}</p>
    <p><strong parentName="p">{`3. `}</strong>{`There are some `}<em parentName="p">{`extremely`}</em>{` awesome demos in that talk. If nothing else, at least skip around to those - there's an epic way to make games, an awesome way to create animations and a pretty cool way of visualizing what your algorithm does `}<em parentName="p">{`as you write it`}</em>{`.`}</p>
    <p>{`There isn't much more I can add to all this, just watch the video and be amazed. Now excuse me while I run off to find my principle.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/dd/2012/02/27/can-code-really-be-poetry/"
        }}>{`Can code really be poetry?`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gangsgoonsandgunz.rahrahrecords.com/articles/inventing-principle-video/"
        }}>{`Inventing on principle `}{`[`}{`Video`}{`]`}</a>{` (gangsgoonsandgunz.rahrahrecords.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tatiyants.com/lipstick-on-a-pig-is-not-ux/"
        }}>{`Lipstick on a Pig is Not UX`}</a>{` (tatiyants.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://boingboing.net/2012/02/15/technology-interaction-and-eth.html"
        }}>{`Technology interaction and ethics: how to live a good life and make a better world`}</a>{` (boingboing.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7ae8e756-035a-4e43-b841-fdc9eccdd3f9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      